import createSagaMiddleware from "@redux-saga/core";
import { configureStore } from "@reduxjs/toolkit";
import { rootSaga } from "./rootSaga";
import allowedChangesSlice from "./slices/allowedChangesSlice";
import applicationSlice from "./slices/applicationSlice";
import counterSlice from "./slices/counterSlice";
import stepperSlice from "./slices/stepperSlice";

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
    reducer: {
        counter: counterSlice,
        stepper: stepperSlice,
        application: applicationSlice,
        allowedChanges: allowedChangesSlice,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(sagaMiddleware),
});

export const sagaMiddlewareTask = sagaMiddleware.run(rootSaga);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
